import { Outlet } from "react-router-dom";
import SiteNav from "@/components/SiteNav";
import SiteFooter from "@/components/SiteFooter";

export default function SiteLayout() {
    return (
        <div className="relative min-h-screen flex flex-col" data-testid="site-layout">
            <SiteNav />
            <main className="flex-1" data-testid="site-main">
                <Outlet />
            </main>
            <SiteFooter />
        </div>
    );
}
